<template>
  <div
    class="color-option"
    :class="{ 'only-circle': showOnlyCircle }"
    @click="emitSelectColor"
  >
    <ColorCircle :color="color" :selectedColorId="selectedColorId" />
    <p
      class="color-name"
      :class="{ 'slate-bold': isSelected }"
      v-if="!showOnlyCircle"
    >
    {{ color && color.family_name && color.family_name.toLowerCase() }}
    </p>
  </div>
</template>


<script>
import ColorCircle from "@/components/Projects/Project/Colors/ColorCircle.vue";
export default {
  name: "ColorOptionsItem",
  components: {
    ColorCircle,
  },
  props: {
    color: {
      type: Object,
    },
    colorKey: {
      type: String,
    },
    selectedColorId: {
      type: Number,
    },
    showOnlyCircle: {
      type: Boolean,
    },
  },

  methods: {
    emitSelectColor() {
      this.$emit("selectColor", { color: this.color, colorKey: this.colorKey });
    },
  },
  computed: {
    isSelected() {
      return Number(this.color.id) === Number(this.selectedColorId);
    },
  },
};
</script>

<style lang="scss" scoped>
$border-width: 3px;
$border-radius: 2.25rem;
.color-option {
  border-radius: 6px;
  padding: 0.25rem;
  transition: all 0.1s;
  &:not(.only-circle) {
    &:hover {
      cursor: pointer;
      background: $grey-light;
    }
    .color-circle {
      margin-right: 1rem;
    }
  }

  .color-name {
    text-transform: capitalize;
  }
}

.color-circle {
  cursor: pointer;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.16);
  border-radius: $border-radius;
  width: 30px;
  height: 30px;

  &:not(.only-circle) {
    //buscar manera de usar el amrgin right 1 rem en el losc ircles
    &.selected {
      border: $border-width solid black;
    }
  }

  .white-border {
    border: $border-width solid #ffffff;
    border-radius: $border-radius;
    width: 100%;
    height: 100%;

    .color-fill {
      border-radius: $border-radius;
      width: 100%;
      height: 100%;
      border: 1px solid $grey-light;
    }
  }
}
</style>